import React from "react";
import { Link } from "react-router-dom";

export const FEATURED_WHITE_PAPER_PATH = "/publication/verifytt-embedding-trust";
export const PUBLICATIONS_LIBRARY_PATH = "/publication/library";

export const featuredDocuments = [
  {
    tag: "FEATURED WHITE PAPER",
    title: "VerifyTT: Embedding Trust in the Digital Economy of Trinidad and Tobago",
    description: "This white paper was prepared by iGovTT as part of its mandate to design, implement, and steward national digital infrastructure initiatives.",
    author: "Irwin Williams | Head of Software Development, iGovTT",
    to: FEATURED_WHITE_PAPER_PATH,
    fullWidth: true,
  },
  // {
  //   tag: "WHITE PAPER",
  //   title: "Rorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc vulputate libero et velit interdum",
  //   description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc vulputate libero et velit interdum, ac aliquam odio malesuada.",
  //   author: "Irwin Williams | Head of Software Development, iGovTT",
  // },
  // {
  //   tag: "WHITE PAPER",
  //   title: "Rorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc vulputate libero et velit interdum",
  //   description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc vulputate libero et velit interdum, ac aliquam odio malesuada.",
  //   author: "Irwin Williams | Head of Software Development, iGovTT",
  // },
];

export const libraryDocuments = [
  {
    tag: "WHITE PAPER",
    title: "VerifyTT: Embedding Trust in the Digital Economy of Trinidad and Tobago",
    description: "This white paper was prepared by iGovTT as part of its mandate to design, implement, and steward national digital infrastructure initiatives.",
    author: "Irwin Williams | Head of Software Development, iGovTT",
    to: FEATURED_WHITE_PAPER_PATH,
  },
  // {
  //   tag: "PUBLICATION",
  //   title: "Worem ipsum dolor sit amet, consectetur adipiscing elit. Nunc vulputate libero et velit interdum,",
  //   description: "Worem ipsum dolor sit amet, consectetur adipiscing elit. Nunc vulputate libero et velit interdum, ac aliquet odio mattis.",
  // },
  // {
  //   tag: "GUIDE",
  //   title: "Worem ipsum dolor sit amet, consectetur adipiscing elit. Nunc vulputate libero et velit interdum,",
  //   description: "Worem ipsum dolor sit amet, consectetur adipiscing elit. Nunc vulputate libero et velit interdum, ac aliquet odio mattis.",
  // },
];

const PublicationsDocumentGrid = ({ documents, ariaLabel = "Publications documents" }) => {
  return (
    <div className="grid grid-cols-1 gap-6 md:grid-cols-3" aria-label={ariaLabel}>
      {documents.map((doc) => (
        <article
          key={`${doc.tag}-${doc.title}`}
          className={`flex min-h-[318px] flex-col rounded-[18px] border border-[#dfe4ee] bg-white shadow-[0_8px_24px_rgba(15,23,42,0.06)] transition-all duration-200 hover:shadow-[0_14px_32px_rgba(15,23,42,0.10)] ${doc.fullWidth ? "md:col-span-3" : ""}`}
        >
          <div className="flex flex-1 flex-col gap-4 p-6">
            <span className="mb-4 inline-flex w-fit items-center rounded-full bg-[#387FF51A] px-6 py-2 text-[14px] font-normal uppercase text-[#116DFD]">
              {doc.tag}
            </span>
            <h3 className="m-0 text-[20px] font-bold text-[#141c2f]">{doc.title}</h3>
            <p className="m-0 text-[12px] font-normal italic text-[#222831]">{doc.description}</p>

            <div className="mt-auto flex flex-col gap-5 pt-3">
              {doc.author ? (
                <p className="m-0 text-[12px] leading-[1.5] text-[#677089]">
                  <span className="font-semibold text-[#2f3647]">Lead Author:</span>{" "}
                  {doc.author}
                </p>
              ) : null}

              <div>
                {doc.to ? (
                  <Link
                    to={doc.to}
                    className="mt-5 inline-flex min-h-[34px] items-center rounded-[8px] bg-[#11192c] px-5 py-3 text-[14px] font-semibold text-white no-underline shadow-[0_3px_8px_rgba(15,23,42,0.16)] transition-opacity hover:opacity-85"
                  >
                    Read Report
                  </Link>
                ) : (
                  <button
                    type="button"
                    className="mt-5 inline-flex min-h-[34px] items-center rounded-[8px] bg-[#11192c] px-5 py-3 text-[14px] font-semibold text-white shadow-[0_3px_8px_rgba(15,23,42,0.16)] transition-opacity hover:opacity-85"
                  >
                    Read Report
                  </button>
                )}
              </div>
            </div>
          </div>
        </article>
      ))}
    </div>
  );
};

export default PublicationsDocumentGrid;
